import { single } from "rxjs/operators";
import { AnaColumn } from "../forms-template.service";
import { aspect } from "./aspect";

export const configurazioneDatabaseAziendale: AnaColumn[] = [
  {
    itemType: "group", colCount: "2", class: 'no-line-caption mt-4',
     data: [ // class: 'mt-5'
      {
        type: 'campo',
        dataField: "dbInstance",
        class:'database_consultant',
        nCol: 10,
        dataType: "",
        caption: "Host"
        // validation: [{
        //   type: 'required', message: 'È richiesto un titolo'
        // },
        //]
      },
     

      { type: 'empty', colSpan: '2', },
      {
        type: 'campo',
        dataField: "dbName",
        class:'database_consultant',
        nCol: 10,
        dataType: "",
        caption: "Nome Database"
        // validation: [{
        //   type: 'required', message: 'È richiesto un titolo'
        // },
        //]
      },
      { type: 'empty', colSpan: '2', },
     
      
      {
        type: 'campo',
         dataField: "dbUser",
        class:'database_consultant',
        nCol: 5,
        dataType: "",
        caption: "Utente"
        // validation: [{
        //   type: 'required', message: 'È richiesto un titolo'
        // },
        //]
      },
      {
        type: 'campoPassword', 
        dataField: "dbPassword", 
        nCol: 5,
        dataType: "password", 
        class:'database_consultant',
        caption: "Password",  
        mode:'password',
        validation: [
          { type: "required", message: "Passowrd  Obbligatoria" }
        ]
        // validation: [{
        //   type: 'required', message: 'È richiesto un titolo'
        // },
        //]
      },
      { type: 'empty', colSpan: '2', },
      // {
      //   type: 'campo',
      //   editorType: 'dxNumberBox',
      //   dataField: "numeroMaxDispositiviMobili",
      //   class:'database_consultant',
      //   nCol: 5,
      //   dataType: "",
      //   caption: "Max dispositivi App Mobile"
      //   // validation: [{
      //   //   type: 'required', message: 'È richiesto un titolo'
      //   // },
      //   //]
      // },
      // {
      //   type: 'campo',
      //   editorType: 'dxNumberBox',
      //   dataField: "quotaConsulentiInMegaBytes",
      //   class:'database_consultant',
      //   nCol: 5,
      //   dataType: "",
      //   caption: "Quota consulenti(MB)"
      //   // validation: [{
      //   //   type: 'required', message: 'È richiesto un titolo'
      //   // },
      //   //]
      // },

     
    ]
  },


]